<template>
  <h1 class="title has-text-centered is-spaced">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <go-to-dashboard-button />

    <span
      >{{ purchasesInvoicesQty }}
      {{ $t("invoice.invoiceTitle") }}&nbsp;&nbsp;</span
    >

    <button
      class="button"
      @click="$emit('get-purchases-invoices')"
      :style="c1 ? 'margin-top: 1rem;' : ''"
    >
      <b-icon icon="sync-alt"></b-icon>
    </button>

    <span v-show="!c2">&nbsp;&nbsp;&nbsp;</span>

    <span
      :style="
        c1 || c2
          ? 'position: relative; top: -0.1rem;'
          : 'position: relative; top: -1.1rem;'
      "
    >
      <b-datepicker
        style="width: 210px; display: inline-block;"
        :placeholder="$t('invoice.selectPeriod')"
        v-model="dates"
        range
        @input="$emit('update-dates', dates)"
        :mobile-native="false"
      ></b-datepicker>
    </span>

    <button
      class="button is-pulled-right"
      @click="$emit('sync-invoices')"
      :style="c1 ? 'margin-top: 1rem;' : ''"
      v-if="permissions.canSyncPurchasesInvoices"
    >
      <b-icon icon="satellite-dish"></b-icon>
    </button>

    <hr />
  </h1>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { responsive } from "../../mixins/responsive";
import { mask } from "../../mixins/mask";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  mixins: [common, responsive, mask],

  components: {
    goToDashboardButton
  },

  data() {
    return {
      isLoading: false,
      dates: null,
      merchantsAndStores: [],
      dropdownList: [this.$t("invoice.allMerchants")],
      filter: "transactions-payments",
      ms: ""
    };
  },

  methods: {},

  computed: {
    ...mapGetters(["permissions", "purchasesInvoicesQty"]),

    c1() {
      return this.windowWidth < 751 && this.windowWidth > 381;
    },

    c2() {
      return this.windowWidth < 382;
    },

    filteredData() {
      return this.dropdownList.filter(option => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.ms.toLowerCase()) >= 0
        );
      });
    }
  },

  mounted() {
    this.dates = [new Date(), new Date()];
  }
};
</script>

<style scoped>
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
